export const CLEAN_STATE = 'CLEAN_STATE';

 
export function cleanState(initialState: any) {
  return {
    type: CLEAN_STATE,
    state: initialState,
  };
}
